import Cropper from 'cropperjs';
import mime from 'mime';

const maxAssetsSize = 2560;
const thumbnailSize = 480;

function calculateSizeToFitMaxSize(img, maxSize) {
  let width;
  let height;
  if (img.width > img.height) {
    width = Math.min(img.width, maxSize);
    height = parseInt((img.height * width) / img.width, 10);
  } else {
    height = Math.min(img.height, maxSize);
    width = parseInt((img.width * height) / img.height, 10);
  }
  return {
    width,
    height,
  };
}

export default {
  read(file, maxSize = maxAssetsSize, maxThumbnailSize = thumbnailSize) {
    const imageType = mime.getType(file.name);

    return new Promise((resolve, reject) => {
      const img = new Image();
      const url = URL.createObjectURL(file);

      img.onerror = () => {
        reject('Error while loading image: image loading failed');
      };

      img.onload = () => {
        const { width, height } = calculateSizeToFitMaxSize(img, maxSize);
        const { width: thumbnailWidth, height: thumbnailHeight } = calculateSizeToFitMaxSize(img, maxThumbnailSize);

        const container = document.createElement('div');
        container.style.position = 'absolute';
        container.style.top = '-9999px'; // Move it off-screen
        container.style.width = `${width}px`;
        container.style.height = `${height}px`;
        document.body.appendChild(container);
        container.appendChild(img);

        const cropper = new Cropper(img, {
          aspectRatio: width / height,
          viewMode: 1,
          autoCrop: true,
          autoCropArea: 1,
          ready() {
            const croppedCanvas = cropper.getCroppedCanvas({
              width,
              height,
            });

            const thumbnailCanvas = document.createElement('canvas');
            thumbnailCanvas.width = thumbnailWidth;
            thumbnailCanvas.height = thumbnailHeight;

            const ctx = thumbnailCanvas.getContext('2d');
            ctx.drawImage(croppedCanvas, 0, 0, thumbnailWidth, thumbnailHeight);

            resolve({
              photo: croppedCanvas.toDataURL(imageType, 0.7),
              thumbnail: thumbnailCanvas.toDataURL(imageType, 0.5),
              width,
              height,
              resized: img.width !== width || img.height !== height,
            });

            cropper.destroy();
            document.body.removeChild(container);
            URL.revokeObjectURL(url);
          },
        });
      };

      img.src = url;
    });
  },
};
